<template>
    <div class="h-logo" v-if="isShowMenu">
        <router-link class="h-logo-link" :to="link"
                     @click.native="logo()">
            <span class="icon"></span>
        </router-link>

        <tooltip ref="tooltipNotifyReset"
                 :direction="'bottom-center-direction'"
                 :add-class-wrap="'h-logo__tooltip'"
                 :isBtnClose="false"
                 :add-style="{width: 175 + 'px'}">
            <span slot="tooltipBtn"></span>

            <div slot="tooltipContent">
                <div class="text-center">
                    <div>
                        <a href="" class="i i-refresh2 i--blue"></a>
                    </div>
                    <div class="text-size-s" style="margin-top: 4px; ">
                        Мы обновили сайт.<br>
                        Чтобы все заработало –<br>
                        <a href="">перезагрузите</a> страницу
                    </div>
                </div>
            </div>
        </tooltip>
    </div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue'
    import {mapState} from "vuex";

    export default {
        name: "HeaderLogo",
        components: {
            Tooltip,
        },
        computed: {
            ...mapState({
                user: state => state.users.user,
                isSearch: state => state.rules.isSearch,
                popups: state => state.popups.items,
            }),
            isShowMenu() {
                return (!(this.$route.name === 'cooperation-edit') &&
                    !(this.$route.name === 'provider-edit') &&
                    !(this.$route.name === 'providers-about-edit') &&
                    !(this.$route.name === 'partner-about-edit') &&
                    !(this.$route.name === 'coupons-about-edit') &&
                    !(this.$route.name === 'coupons-detail') &&
                    !(this.$route.name === 'coupons-edit') &&
                    !(this.$route.name === 'repayment-detail'));
            },
            link() {
                switch (this.$route.name) {
                    case 'moderator-contract':
                    case 'moderator-contract-detail':
                        if(this.user.access_rights.is_owner || !this.user.is_can_dismiss && this.user.is_can_contract){
                            return '/staff/contract/';
                        } else {
                            return '/staff/';
                        }

                    case 'moderator-staff':
                        return '/staff/';
                    case 'moderator-contacts':
                        return '/contacts/';
                    default:
                        return '/';
                }
            },
        },
        methods: {
            logo(){
                if (this.isSearch) {
                    this.$store.commit('rules/setIsSearch', false);
                    this.$store.commit('popups/close', { name: this.popups.ruleDetail.name });
                    return;
                }
                switch (this.$route.name) {
                    case 'moderator-contacts':
                        if(document.getElementById('first-group-item')){
                            document.getElementById('first-group-item').click();
                        }
                    break;
                }
            }
        }
    }
</script>

<style scoped>

</style>
